export default {
  AUTHENTICATE_SUCCESS: 'AUTHENTICATE_SUCCESS',
  AUTHENTICATE_FAILURE: 'AUTHENTICATE_FAILURE',
  USER_LOADED: 'USER_LOADED',
  FLASH: 'FLASH',
  UNFLASH: 'UNFLASH'
}



// WEBPACK FOOTER //
// ./src/store/mutation-types.js